import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'nk-select-all-button',
  imports: [TranslateModule],
  templateUrl: './select-all-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectAllButtonComponent {
  @Input() public isAllSelected = false;
  @Output() public setSelectAll = new EventEmitter<boolean>();

  public selectAll(event: Event, state: boolean): void {
    event.stopPropagation();
    event.preventDefault();
    this.setSelectAll.emit(state);
  }
}
